import styled from 'styled-components';
import {dFlex, alignCenter, justifyBetween, alignStart} from '../../../../../../globalVariables/GlobalFlex';
import {GRAY, LIGHT_GRAY2, STATUS_ACTIVE_BG, STATUS_ACTIVE_TEXT, STATUS_INACTIVE_BG, STATUS_INACTIVE_TEXT, STATUS_EXPIRED_BG, STATUS_EXPIRED_TEXT, STATUS_DRAFT_BG, STATUS_DRAFT_TEXT, DARK_GRAY2, BGImageCenter, ellipsisLines} from '../../../../../../globalVariables/GlobalVariables';
import {popUpBody} from '../../../../../../component/newPopup/mobilePopup/MobilePopup.css';
import {getToken} from '@tickchak/react-share/app';

export const popupWrapper = styled.div<{eventImage?: string}>`
    position: relative;
    height: 100%;
    ${popUpBody}{
        min-height: 100px;
        overflow: visible;
        &::before {
            content: '';
            position: absolute;
            inset-block-start: -40px;
            inset-inline-start: calc(50% - 40px);
            width: 80px;
            height: 80px;
            border-radius: 50%;
            ${p=>BGImageCenter(p.eventImage || '', 'cover')}
        }
    }
`;

export const container = styled.div`
    padding: 20px;
    padding-top: 14px;
    width: 100%;
`;

export const topLine = styled.div`
    ${dFlex}
    ${justifyBetween}
    ${alignStart}
    margin-bottom: 20px;
    gap: 16px;
`;

export const rightSection = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: 12px;
`;

export const eventTitle = styled.div`
    font-weight: 600;
    color: ${getToken('color.text.default')};
`;

export const detailsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px 20px;
    padding-top: 20px;
`;

export const detailItem = styled.div`
    ${dFlex}
    ${justifyBetween}
`;

export const label = styled.span`
    font-weight: 600;
    color: ${DARK_GRAY2};
    letter-spacing: 0.5px;
`;

export const value = styled.span`
    ${ellipsisLines(1)}
    color: ${getToken('color.text.default')};
`;

export const statusBadge = styled.div<{status: string}>`
    padding: 6px 12px;
    border-radius: 16px;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    color: ${props => {
    switch (props.status) {
        case 'active': return STATUS_ACTIVE_TEXT;
        case 'inactive': return STATUS_INACTIVE_TEXT;
        case 'expired': return STATUS_EXPIRED_TEXT;
        case 'draft': return STATUS_DRAFT_TEXT;
        default: return GRAY;
    }
}};
    background: ${props => {
    switch (props.status) {
        case 'active': return STATUS_ACTIVE_BG;
        case 'inactive': return STATUS_INACTIVE_BG;
        case 'expired': return STATUS_EXPIRED_BG;
        case 'draft': return STATUS_DRAFT_BG;
        default: return LIGHT_GRAY2;
    }
}};
    min-width: 80px;
    white-space: nowrap;
`;

export const checkboxContainer = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: 8px;
`;

export const successIcon = styled.div`
    width: 18px;
    height: 18px;
`;